import { ReactNode } from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { ChatAssistant } from "../ChatAssistant";
import { NotificationBanner, useBannerHeight } from "../NotificationBanner";

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const bannerHeight = useBannerHeight();
  
  return (
    <div className="min-h-screen flex flex-col">
      <NotificationBanner />
      <Navbar />
      <main 
        className="flex-1 transition-all duration-300" 
        style={{ paddingTop: `calc(5rem + ${bannerHeight}px)` }}
      >
        {children}
      </main>
      <Footer />
      <ChatAssistant />
    </div>
  );
}
